import { Description } from '../../../components/Description';
import { Headline } from '../../../components/Headline';
import { Playground } from '../../../components/playground/Playground';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';

export const FieldSizing = () => (
    <div>
        <Headline anchor='field-sizing'>Field sizing</Headline>
        <Description>
            Use <code>field-sizing: content</code> to let a form control grow with its content. Combine it with minimum
            and maximum height classes to constrain how far the field can grow.
        </Description>
        <Playground example={fieldSizingExample} classes={fieldSizingClasses} />
    </div>
);

const fieldSizingExample = (
    <div className='display-flex gap-25 flex-wrap'>
        <div className='form-group min-width-300'>
            <label htmlFor='field-sizing-content-1'>Message</label>
            <textarea
                id='field-sizing-content-1'
                className='form-control field-sizing-content resize-none min-height-3lh max-height-10lh'
                placeholder='Enter a message'
            />
        </div>
        <div className='form-group min-width-300'>
            <label htmlFor='field-sizing-content-2'>Comment</label>
            <textarea
                id='field-sizing-content-2'
                className='form-control field-sizing-content min-height-3lh max-height-10lh'
                placeholder='Enter a message'
            />
        </div>
    </div>
);

const fieldSizingClasses = (
    <>
        <PlaygroundClasses label='Field sizing' classes='field-sizing-content' />
        <PlaygroundClasses label='Minimum height' classes='min-height-3lh' />
        <PlaygroundClasses label='Maximum height' classes='max-height-10lh' />
    </>
);
